(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cbredirect"]) return;
  try {
    
  function setCookie(name, value, expires, path, domain, secure) {
    var today = new Date();

    today.setTime(today.getTime());

    if (expires) {
      expires = expires * 1000 * 60 * 60 * 24;
    }

    var expires_date = new Date(today.getTime() + expires);

    document.cookie =
      name +
      "=" +
      escape(value) +
      (expires ? "; expires=" + expires_date.toGMTString() : "") +
      (path ? ";path=" + path : "") +
      (domain ? "; domain=" + domain : "") +
      (secure ? "; secure" : "");
  }

  function getVar(name) {
    get_string = document.location.search;

    return_value = "";

    do {
      name_index = get_string.indexOf(name + "=");

      if (name_index != -1) {
        get_string = get_string.substr(
          name_index + name.length + 1,
          get_string.length - name_index
        );

        end_of_value = get_string.indexOf("&");

        if (end_of_value != -1) {
          value = get_string.substr(0, end_of_value);
        } else {
          value = get_string;
        }

        if (return_value == "" || value == "") {
          return_value += value;
        } else {
          return_value += ", " + value;
        }
      }
    } while (name_index != -1);
    {
      space = return_value.indexOf("+");
    }

    while (space != -1) {
      return_value =
        return_value.substr(0, space) +
        " " +
        return_value.substr(
          space + 1,

          return_value.length
        );

      space = return_value.indexOf("+");
    }

    return return_value;
  }

  function redirTo() {
    var strReturn = "";

    var strHref = document.location.href;

    if (strHref.indexOf("&url=") > -1) {
      strReturn = strHref.substr(strHref.indexOf("&url=") + 5);
    } else {
      strReturn = "https://duefashion.com/";
    }

    return strReturn;
  }

  var mytduid = getVar("tduid");

  console.log(mytduid);

  if (mytduid != "") {
    setCookie("TRADEDOUBLER", mytduid, 365, "/", "www.duefashion.com");

    setCookie("TRADEDOUBLER", mytduid, 365, "/", " duefashion.com");
  }

  window.location = redirTo();


  } catch(e) { console.error(e); }
})();
})();
